var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.938,
    height: 13.859,
    viewBox: "0 0 9.938 13.859",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stock_exchange_sector_oil_fuel_gasoline",
    "data-name": "Stock, exchange, sector, oil, fuel, gasoline",
    transform: "translate(-25.14 -15.35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_206276",
    "data-name": "Path 206276",
    d: "M32.886,18.845c-.514-.85-1.072-1.688-1.572-2.365-.846-1.13-1.018-1.13-1.2-1.13s-.354,0-1.2,1.13c-.5.67-1.058,1.508-1.572,2.359-.82,1.352-2.2,3.855-2.2,5.4a4.969,4.969,0,1,0,9.938,0C35.082,22.7,33.714,20.2,32.886,18.845Zm.08,7.272a.4.4,0,1,1-.7-.388,2.548,2.548,0,0,0,.21-2.247.4.4,0,0,1,.718-.356A3.351,3.351,0,0,1,32.966,26.117Z",
    fill: "#353535"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLube);
export default __webpack_public_path__ + "static/media/lube.ea6ac4e42daa8117d069296fcf190a8a.svg";
export { ForwardRef as ReactComponent };